import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-panel" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "password-field" }
const _hoisted_6 = ["type"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["disabled"]

import { reactive, ref } from "vue";
import { login } from "@/Shared/services/authService";
import { toast } from "@/Shared/services/toastService";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const credentials = reactive({ login: "", password: "" });
const loading = ref(false);
const showPassword = ref(false);

async function submit() {
  loading.value = true;
  try {
    await login(credentials.login, credentials.password);
  } catch (exception) {
    toast.danger((exception as Error).message);
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[7] || (_cache[7] = _createStaticVNode("<section class=\"login-intro\" data-v-3d6d70d8><div class=\"login-logo\" aria-label=\"Cotisation Section Lyon\" data-v-3d6d70d8><div class=\"login-monogram\" aria-hidden=\"true\" data-v-3d6d70d8><span data-v-3d6d70d8>C</span><span data-v-3d6d70d8>S</span><span data-v-3d6d70d8>L</span></div><strong data-v-3d6d70d8>Section Lyon</strong></div><div data-v-3d6d70d8><span class=\"eyebrow\" data-v-3d6d70d8>Espace trésorerie</span><h1 data-v-3d6d70d8>Une gestion financière claire et sécurisée.</h1><p data-v-3d6d70d8> Retrouvez les cotisations, les bilans et les rappels dans un espace réservé aux utilisateurs autorisés. </p></div><small data-v-3d6d70d8><i class=\"bi bi-shield-check\" data-v-3d6d70d8></i> Session privée · Données locales</small></section>", 1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("form", {
        class: "login-card",
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _cache[6] || (_cache[6] = _createElementVNode("div", null, [
          _createElementVNode("span", { class: "eyebrow" }, "Authentification"),
          _createElementVNode("h2", null, "Bienvenue"),
          _createElementVNode("p", null, "Connectez-vous avec votre identifiant ou votre adresse mail.")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "login" }, "Identifiant ou adresse mail", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "login",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((credentials.login) = $event)),
            class: "input",
            autocomplete: "username",
            autofocus: "",
            required: ""
          }, null, 512), [
            [
              _vModelText,
              credentials.login,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "password" }, "Mot de passe", -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((credentials.password) = $event)),
              class: "input",
              type: showPassword.value ? 'text' : 'password',
              autocomplete: "current-password",
              required: ""
            }, null, 8, _hoisted_6), [
              [_vModelDynamic, credentials.password]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "password-toggle",
              "aria-label": 
                showPassword.value
                  ? 'Masquer le mot de passe'
                  : 'Afficher le mot de passe'
              ,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(showPassword.value ? 'bi bi-eye-slash' : 'bi bi-eye')
              }, null, 2)
            ], 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("button", {
          class: "button login-button",
          disabled: loading.value
        }, [
          _createElementVNode("span", null, _toDisplayString(loading.value ? "Connexion…" : "Se connecter"), 1),
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
        ], 8, _hoisted_8)
      ], 32)
    ])
  ]))
}
}

})